import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v8.5","key":"svg-0"}],["path",{"d":"M9 4v13","key":"svg-1"}],["path",{"d":"M15 7v8","key":"svg-2"}],["path",{"d":"M16 19h6","key":"svg-3"}],["path",{"d":"M19 16v6","key":"svg-4"}]]

const IconMapPlus = createReactComponent('outline', 'map-plus', 'MapPlus', __iconNode);

export default IconMapPlus;